import { CandleResolution } from '@drift-labs/sdk';

export const CandleResolutions: CandleResolution[] = [
	'1',
	'5',
	'15',
	'60',
	'240',
	'D',
	'W',
	'M',
];
